export const COUNTRY_AUSTRALIA = "Australia";
export const COUNTRY_AUSTRALIA_CODE = "AU";

export const COUNTRY_CANADA = "Canada";
export const COUNTRY_CANADA_CODE = "CA";

export const COUNTRY_FRANCE = "France";
export const COUNTRY_FRANCE_CODE = "FR";

export const COUNTRY_UK = "United Kingdom";
export const COUNTRY_UK_CODE = "GB";

export const COUNTRY_US = "United States";
export const COUNTRY_US_CODE = "US";

export const COUNTRY_BR = "Brazil";
export const COUNTRY_BR_CODE = "BR";

export const COUNTRY_IN = "India";
export const COUNTRY_IN_CODE = "IN";

export const COUNTRY_MX = "Mexico";
export const COUNTRY_MX_CODE = "MX";

export const COUNTRY_CN = "China";
export const COUNTRY_CN_CODE = "CN";

export const COUNTRY_AR = "Argentina";
export const COUNTRY_AR_CODE = "AR";

export const COUNTRY_MY = "Malaysia";
export const COUNTRY_MY_CODE = "MY";

export const STRIPE_VALIDATED_COUNTRIES: string[] = [
  COUNTRY_US,
  COUNTRY_US_CODE,
  COUNTRY_CANADA,
  COUNTRY_CANADA_CODE,
  COUNTRY_AUSTRALIA,
  COUNTRY_AUSTRALIA_CODE,
] as const;

export const COUNTRIES_WITH_STATE_FIELD: string[] = [
  ...STRIPE_VALIDATED_COUNTRIES,
  COUNTRY_BR,
  COUNTRY_BR_CODE,
  COUNTRY_IN,
  COUNTRY_IN_CODE,
  COUNTRY_MX,
  COUNTRY_MX_CODE,
  COUNTRY_CN,
  COUNTRY_CN_CODE,
  COUNTRY_AR,
  COUNTRY_AR_CODE,
  COUNTRY_MY,
  COUNTRY_MY_CODE,
] as const;
